module.exports = __webpack_public_path__ + "img/TW.810dab53.png";